import type { IErrorDetail, IErrorResponse, IErrors } from "Common/Interfaces";

const getErrorMessage = (errors: IErrors): string | undefined => {
  for (const key in errors) {
    if (errors[key].length > 0) {
      return errors[key][0]?.message;
    }
  }
  return undefined;
};

const getErrorCode = (errors: IErrors): string | undefined => {
  for (const key in errors) {
    if (errors[key].length > 0) {
      return errors[key][0]?.code;
    }
  }
  return undefined;
};

const getErrorDetail = (response: IErrorResponse, defaultMessage: string): IErrorDetail => {
  if ("errors" in response.data) {
    const message = getErrorMessage(response.data.errors);
    const code = getErrorCode(response.data.errors);
    if (message) {
      return { message, status: response.status, code: code };
    }
  } else if (response.data) {
    return {
      message: response.data.detail || response.data.title || defaultMessage,
      status: response.data.status || response.status,
    };
  }
  return {
    message: defaultMessage,
    status: response.status,
  };
};

export const transformErrorResponse = (response: IErrorResponse): IErrorDetail => {
  try {
    switch (response.status) {
      case 400:
        return getErrorDetail(response, "An error occurred while processing the request");
      case 401:
        return getErrorDetail(response, "Unauthorized access");
      case 404:
        return getErrorDetail(response, "Resource not found");
      case 500:
        return getErrorDetail(response, "Internal server error");
      default:
        return {
          message: "An error occurred while processing the request",
          status: response.status,
        };
    }
  } catch (error) {
    return {
      message: `An unexpected error occurred: ${error instanceof Error ? error.message : "Unknown error"}`,
      status: 500,
    };
  }
};
